import { GraphQLClient } from 'graphql-request'
import Queries from './graphql/queries'
import Mutations from './graphql/mutations'

const API = '/api/graphql'

function getShop(payload) {
  return new GraphQLClient(API).request(Queries.Shop, payload).then(data => data.Shop)
}

function selectItem(id, options = {}) {
  let { accessToken } = options
  return new GraphQLClient(API, {
    headers: {
      authorization: `Basic ${accessToken}`,
    },
  })
    .request(Mutations.ShopSelectItem, { id })
    .then(data => data.ShopSelectItem)
}

function unselectItem(id, options = {}) {
  let { accessToken } = options
  return new GraphQLClient(API, {
    headers: {
      authorization: `Basic ${accessToken}`,
    },
  })
    .request(Mutations.ShopUnselectItem, { id })
    .then(data => data.ShopUnselectItem)
}

export { getShop, selectItem, unselectItem }
